import React from 'react';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';

function looksLikeImage(url: string): boolean {
  return /\.(png|jpe?g|gif|webp|heic)(\?|$)/i.test(url);
}

export type PagoAdjuntosLinksProps = {
  comprobanteUrl?: string | null;
  reciboUrl?: string | null;
  onResendRecibo?: () => void;
  canResend?: boolean;
  onGenerateRecibo?: () => void;
  generatingRecibo?: boolean;
};

export function PagoAdjuntosLinks({
  comprobanteUrl,
  reciboUrl,
  onResendRecibo,
  canResend,
  onGenerateRecibo,
  generatingRecibo,
}: PagoAdjuntosLinksProps) {
  if (!comprobanteUrl && !reciboUrl && !onResendRecibo && !onGenerateRecibo) return null;

  return (
    <div className="mt-2 space-y-2">
      {comprobanteUrl ? (
        <div>
          {looksLikeImage(comprobanteUrl) ? (
            <a href={comprobanteUrl} target="_blank" rel="noopener noreferrer" className="block">
              <img
                src={comprobanteUrl}
                alt="Comprobante de pago"
                className="h-20 w-full rounded-md border border-gray-200 object-cover"
              />
            </a>
          ) : null}
          <a
            href={comprobanteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-block text-[11px] font-medium text-[#1A56DB] hover:underline"
          >
            Ver comprobante
          </a>
        </div>
      ) : null}
      <div className="flex flex-wrap gap-2">
        {reciboUrl ? (
          <a
            href={reciboUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white px-2 py-1 text-[11px] font-medium text-gray-700 hover:bg-gray-50"
          >
            <DocumentArrowDownIcon className="h-3.5 w-3.5" />
            Recibo
          </a>
        ) : null}
        {!reciboUrl && onGenerateRecibo ? (
          <button
            type="button"
            onClick={onGenerateRecibo}
            disabled={generatingRecibo}
            className="inline-flex items-center gap-1 rounded-md border border-[#1A56DB] bg-white px-2 py-1 text-[11px] font-medium text-[#1A56DB] hover:bg-blue-50 disabled:opacity-50"
          >
            {generatingRecibo ? 'Generando…' : 'Generar recibo'}
          </button>
        ) : null}
        {onResendRecibo ? (
          <button
            type="button"
            onClick={onResendRecibo}
            disabled={canResend === false}
            className="inline-flex items-center gap-1 rounded-md bg-green-600 px-2 py-1 text-[11px] font-medium text-white hover:bg-green-700 disabled:opacity-50"
          >
            Reenviar al cliente
          </button>
        ) : null}
      </div>
    </div>
  );
}
